import * as React from 'react';
import { isPastDate } from 'owa-observable-datetime';
import { observer } from 'mobx-react';
import { OwaDate } from 'owa-datetime';

const styles = require('./ColumnPastDayHighlightBehavior.scss');

export default observer(function ColumnPastDayHighlightBehavior({ date }: { date: OwaDate }) {
    return isPastDate(date) ? <div className={styles.pastHighlight} /> : null;
});
